<!-- DELIVERY INFO -->
<section class="background-grey p-t-40 p-b-0">
    <div class="container">
        <div class="row">
            <div class="col-lg-4">
                <div class="icon-box effect small clean">
                    <div class="icon">
                        <a href="#"><i class="icon-clock icon-blu"></i></a>
                    </div>
                    <h3>Disponibilità reale</h3>
                    <p>La disponibilità dei prodotti è costantemente aggiornata.</p>
                </div>
            </div>

            <div class="col-lg-4"> 
                <div class="icon-box effect small clean">
                    <div class="icon">
                        <a href="#"><i class="icon-truck icon-blu"></i></a>
                    </div>
                    <h3>Ricevi la merce</h3>
                    <p>Ordina sul sito e ricevi la merce presso il tuo magazzino.</p>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="icon-box effect small clean">
                    <div class="icon">
                        <a href="#"><i class="icon-credit-card icon-blu"></i></a>
                    </div>
                    <h3>Pagamento 100% sicuro</h3>
                    <p>Paga online oppure al ritiro.</p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- end: DELIVERY INFO -->